export default function FormFieldTime({ formUtility, field, label, description, className, classNameControl, min, max, disabled = false }) {
    return (
        <div className={className ?? "form-group"}>
            {label?.toString()?.trim().length > 0 ? <label>{label.toString().trim()}</label> : null}
            <input
                name={field}
                value={formUtility.getFieldValue(field)}
                onChange={formUtility.handleChangeControl}
                readOnly={formUtility.fieldsDisabled || disabled}
                disabled={formUtility.fieldsDisabled || disabled}
                min={min}
                max={max}
                type="time"
                className={classNameControl ?? "form-control"} />
            {description?.toString()?.trim().length > 0 ? <p>{description.toString().trim()}</p> : <br />}
        </div>
    );
}